module.exports = __webpack_public_path__ + "img/shadows-into-light-two.png";